var specialCharacters = '!~/-^$%&#?'.split('');

module.exports.shuffleText = (length) => new Array(length).fill('').map((element) => specialCharacters[Math.floor(Math.random()*specialCharacters.length)]);